export const CONTENT_TYPES = {
  FORMAT: "format",
  HTML: "html"
};
